export default {
  zone: {
    code_area: null,
    description: null,
  },
  customer_group: {
    name: null,
    flag: null,
    pointer_color: null,
    description: null,
    type: null
  },
  asset_owner: {
    owner: null,
    name: null,
    description: null,
  },
  asset: {
    asset_owner_id: null,
    serial_number: null,
    file: null,
    description: null,
    status: null,
    image_information:null,
  },
  division: {
    name: null,
    description: null,
  },
  payment_method: {
    name: null,
    description: null,
  },
  position: {
    name: null,
    description: null,
    division_id: null,
    level: null,
  },
  billing_address: {
    name: null,
    address: null,
  },
  route: {
    name: null,
    description: null,
  },
  asset_status: {
    name: null,
    description: null,
  },
  head_office: {
    name: null,
    lat: null,
    lng: null,
    description: null,
  },
  employee_status: {
    name: null,
    description: null,
  },
  access_menu: {
    nik: null,
    menu: null,
    start_page: null,
  },
  change_password: {
    nik: null,
    new_password: null,
  },
  vehicle_delivery: {
    name: null,
    description: null,
  },
  products_group: {
    name: null,
    prefix: null,
    description: null
  },
  verification_template: {
    title: null,
    messages: null,
    category: null,
    show: null
  },
  employee_task_verification: {
    title: null,
    subtitle: null,
    employee_id: null,  
    customer_id: null,  
    template_id: null,
    freezer_request_code: null,
    status_verification: null,
    reason: null,
    category: null,
    date_inserted: null,
    date_show_task: null,
    updated_time: null,
    status: null
  },
  driver_report: {
    employee_id: null,
    asset_car: null,
    total_km: null,  
    lat: null,  
    lng: null,
    attachment: null,
    date_inserted: null
  }
};
